// extracted by mini-css-extract-plugin
export var wrapper = "LoginForm-module__wrapper___hnQ31";
export var forgotPassword = "LoginForm-module__forgotPassword___Dwcbv";
export var sectionDivider = "LoginForm-module__sectionDivider___dNygA";
export var content = "LoginForm-module__content___Pp4Ht";
export var heading = "LoginForm-module__heading___FXS3v";
export var gap = "LoginForm-module__gap___gs3yh";